import React, { useState, useEffect, useRef } from "react";
import HeaderM from "../../Invs/maintaince/A4/HeaderM";
import BodyInv from "./A4/BodyInv";
import FooterD from "./A4/FooterD";
import UnderHeader from "./A4/UnderHeader"
import * as _ from "lodash";
import { ButtonBase, Grid } from "@material-ui/core";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import FooterDH from "./A4/FoooterD3";
import UnderHeadreCar from "../CarMaintance/UnderHeadreCar";
import UnderHeaderD from "../ItemsNotesDesign/UnderHeaderD";
import FooterNotes from "../ItemsNotesDesign/FooterNotes";
import FooterM from "../maintaince/A4/FooterM";
import "./invoiceprint.css"
import InvTotal from "./A4/InvTotal";
import { styleFooterNotesAr, styleFooterNotesEn, stylePadding, stylePaddingFooter, stylePaddingHead } from "../ShareFunctionsPrint";
import FooterD4 from "./A4/FooterD4";
import HeaderAll from "../../HeaderAll";

function HeadersNew(props) {
    const { found, premiApp } = props;
    const clas = useInvAF();
    return (
        <div style={stylePaddingHead}>
            {found.header_img != null ? (
                (
                    <Grid container justifyContent="center" item xs={12}
                        style={{ minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
                        <div>
                            <ButtonBase>
                                {" "}
                                <img
                                    src={`data:image/jpeg;base64,${found.header_img}`}
                                    className={clas.headerImg}
                                    alt={found.nameA}
                                />{" "}
                            </ButtonBase>
                        </div>
                    </Grid>
                )
            ) : premiApp.billTemplate === 17 || premiApp.billTemplate === 20 || premiApp.billTemplate === 31 ?
                <HeaderAll Report={false} found={found} /> :
                <HeaderM foundData={found} />
            }
        </div>
    );

}
function HeadersSecond(props) {
    const { locInv, found, sta, inv, premiApp } = props;
    return (
        <div style={stylePadding}>
            {premiApp.billTemplate === 17 || premiApp.billTemplate == 20 || premiApp.billTemplate == 31 ?
                <UnderHeaderD found={found} inv={inv} sta={sta} locInv={locInv} /> : premiApp.billTemplate === 14 ?
                    <UnderHeadreCar found={found} inv={inv} sta={sta} locInv={locInv} /> :
                    <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />
            }
        </div>
    );
}
function BodyInvoice(props) {
    const { locInv, sta, inv, premiApp, chunk, isLast } = props;
    return (
        <div style={stylePadding}>
            <BodyInv
                data={chunk ?? []}
                isLast={isLast}
                inv={inv}
                sta={sta}
                premiApp={premiApp}
            />
        </div>
    );
}
function FooterNotesCar(props) {
    const { found, premiApp } = props;
    return (
        <div style={stylePadding}>
            {premiApp.billTemplate === 14 ? (
                <Grid container item xs={12} style={{ fontFamily: "Amiri-Regular", paddingTop: "0.5rem", }} >
                    <Grid
                        item container xs={6} style={styleFooterNotesEn}>
                        {found.Disc1_footer_en}
                    </Grid>
                    <Grid
                        item container xs={6} style={styleFooterNotesAr}>
                        {found.Disc1_footer_ar}
                    </Grid>
                </Grid>
            ) : null}
        </div>
    );
}
function Footers(props) {
    const { found, sta, inv, premiApp,locInv } = props;
    return (
        <div className="footerview" style={stylePaddingFooter}>
            {premiApp.billTemplate === 20 || premiApp.billTemplate === 31 ?
                <FooterM found={found} sta={sta} premiApp={premiApp} /> : premiApp.billTemplate === 14 ? null :
                    premiApp.billTemplate === 17 ? <FooterNotes inv={inv} found={found} /> :
                        premiApp.billTemplate === 13 ? <FooterD4 found={found} /> : premiApp.billTemplate === 12 ?
                            <FooterDH found={found} /> : <FooterD found={found} inv={inv} premiApp={premiApp}  locInv={locInv}/>
            }
        </div>
    );
}


function RevInvoicePrint(props) {
    const { locInv, found, sta, inv, data, premiApp } = props;
    const headerFirstRef = useRef(null);
    const headerSecondRef = useRef(null);
    const footerRef = useRef(null);
    const totalsref = useRef(null);
    const footerNotes = useRef(null);

    const rowrefs = useRef([]);
    const [pages, setPages] = useState([]);


    useEffect(() => {
        const calcutepages = async () => {
            if (document.fonts) await document.fonts.ready;
            const PAGE_HEIGHT = 1120;
            const HEADER1 = headerFirstRef.current?.offsetHeight || 0;
            const HEADER2 = headerSecondRef.current?.offsetHeight || 0;
            const FOOTER1 = footerRef.current?.offsetHeight || 0;
            const totalsH = totalsref.current?.offsetHeight || 0;
            const FOOTERNOTESREF = footerNotes.current?.offsetHeight || 0;

            const max_Height = PAGE_HEIGHT - (HEADER1 + HEADER2 + FOOTER1 + FOOTERNOTESREF + 20);

            const heights = rowrefs.current.map(el => el?.offsetHeight || 0);

            let pageInvoice = [];
            let currentPage = [];
            let currentHeight = 0;

            data.forEach((item, i) => {
                const rowHieght = heights[i];
                if (currentHeight + rowHieght > max_Height) {
                    pageInvoice.push(currentPage);
                    currentPage = [];
                    currentHeight = 0;
                }
                currentPage.push(item);
                currentHeight += rowHieght;
            });

            if (currentHeight + totalsH > max_Height) {
                pageInvoice.push(currentPage);
                pageInvoice.push([]);
            } else {
                pageInvoice.push(currentPage);
            }
            setPages(pageInvoice);
        };
        calcutepages();
    }, [data]);


    return (
        <>
            <div className="measurecon" >
                <div ref={headerFirstRef}>
                    <HeadersNew found={found} premiApp={premiApp} />
                </div>
                <div ref={headerSecondRef}>
                    <HeadersSecond locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} />
                </div>
                {data.map((item, i) => (
                    <div key={i}
                        ref={(el) => (rowrefs.current[i] = el)}
                        className="measurerow"
                    >
                        {item.notesall}
                    </div>
                ))}
                <div ref={footerNotes}>
                    <FooterNotesCar found={found} premiApp={premiApp} />
                </div>
                <div ref={totalsref}>
                    <InvTotal inv={inv} sta={sta} premiApp={premiApp} />
                </div>
                <div ref={footerRef}>
                    <Footers found={found} sta={sta ?? {}} inv={inv} premiApp={premiApp} locInv={locInv}/>
                </div>
            </div>

            <div className="invoicepreview">
                {pages.map((page, i) => (
                    <div className="pageinv" key={i}>
                        <div className="contentview">
                            <HeadersNew found={found} premiApp={premiApp} />
                            <HeadersSecond locInv={locInv} found={found} sta={sta} inv={inv} premiApp={premiApp} />
                            <BodyInvoice locInv={locInv} found={found} sta={sta} inv={inv} chunk={page ?? []} isFirst={i == 0} isLast={i == pages.length - 1} premiApp={premiApp} />
                            <FooterNotesCar found={found} premiApp={premiApp} />
                        </div>
                        <Footers found={found} sta={sta ?? {}} inv={inv} premiApp={premiApp} locInv={locInv}/>
                    </div>
                ))}
            </div>
        </>
    );
}
export default RevInvoicePrint;
